<template>
  <div class="realtime-table">
    <table>
      <thead>
        <tr>
          <th>时间</th>
          <th>商品</th>
          <th>平台</th>
          <th>商家</th>
          <th>原价</th>
          <th>当前价</th>
          <th>差价</th>
          <th>状态</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.time + row.product">
          <td>{{ row.time }}</td>
          <td>{{ row.product }}</td>
          <td>{{ row.platform }}</td>
          <td>{{ row.shop }}</td>
          <td>{{ row.origin }}</td>
          <td>{{ row.current }}</td>
          <td :class="row.diff.startsWith('-') ? 'down' : 'up'">{{ row.diff }}</td>
          <td :class="row.statusClass">{{ row.status }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
const rowTemplates = [
  { product: "邵店黄姜干货", platform: "京东", shop: "邵店镇", origin: "39.80", current: "42.80", diff: "+3.00", status: "价格上涨", statusClass: "warn" },
  { product: "黄姜粉", platform: "京东", shop: "邵店镇", origin: "36.80", current: "39.80", diff: "+3.00", status: "高价预警", statusClass: "danger" },
  { product: "上蔡花生礼盒", platform: "拼多多", shop: "黄埠镇", origin: "39.90", current: "36.60", diff: "-3.30", status: "价格回落", statusClass: "ok" },
  { product: "朱里红薯粉条", platform: "本地商城", shop: "朱里镇", origin: "29.90", current: "24.80", diff: "-5.10", status: "低价监测", statusClass: "warn" },
  { product: "菌菇礼盒", platform: "京东", shop: "无量寺乡", origin: "82.00", current: "88.00", diff: "+6.00", status: "高于上限", statusClass: "danger" },
  { product: "花生油礼盒", platform: "京东", shop: "黄埠镇", origin: "62.80", current: "68.00", diff: "+5.20", status: "价格上涨", statusClass: "warn" },
  { product: "红薯干", platform: "本地商城", shop: "朱里镇", origin: "18.90", current: "16.80", diff: "-2.10", status: "接近下限", statusClass: "ok" },
];

function padTime(value) {
  return String(value).padStart(2, "0");
}

function formatUpdateTime(date) {
  return `${padTime(date.getHours())}:${padTime(date.getMinutes())}`;
}

function randomMinuteOffset(index) {
  const baseOffsets = [4, 10, 18, 31, 47, 68, 96];
  return baseOffsets[index] + Math.floor(Math.random() * 7);
}

function createUpdateRows() {
  const now = new Date();
  return rowTemplates.map((row, index) => {
    const date = new Date(now);
    date.setMinutes(now.getMinutes() - randomMinuteOffset(index));
    return {
      ...row,
      time: formatUpdateTime(date),
      timestamp: date.getTime(),
    };
  }).sort((a, b) => b.timestamp - a.timestamp);
}

const rows = createUpdateRows();
</script>

<style lang="less" scoped>
.realtime-table {
  height: 100%;
  padding: 20px 26px;
  box-sizing: border-box;
}

table {
  width: 100%;
  border-collapse: collapse;
  color: #cbeaff;
  font-size: 24px;
}

th {
  height: 80px;
  color: #dff7ff;
  font-weight: normal;
  background: rgba(17, 83, 155, 0.58);
}

td {
  height: 60px;
  text-align: center;
  background: rgba(9, 58, 121, 0.34);
  border-bottom: 1px solid rgba(65, 145, 218, 0.18);
}

tbody tr:nth-child(2n) td {
  background: rgba(12, 74, 145, 0.42);
}

.up,
.warn {
  color: #f2d45a;
}

.down,
.ok {
  color: #3ee4c2;
}

.danger {
  color: #ff7188;
}
</style>
